<ng-container *transloco="let t; read: 'layout-results'">
  <div fxLayout="column" fxLayoutGap="1rem">
    <div class="mat-headline-6 color-accent bold">{{ t('Results') }}</div>
    <div fxLayout="column" fxLayoutGap="2rem">
      <ng-content select="[results]"></ng-content>
    </div>
  </div>
</ng-container>
